import * as _ from "underscore";

export enum WithdrawnReasons {
  CalledTooSlow = "called_too_slow",
  ClonedToNewApplication = "cloned_to_new_application",
  LostOnCredits = "lost_on_credits",
  LostOnRate = "lost_on_rate",
  LostToAgentsLender = "lost_to_agents_lender",
  LostToClientsBank = "lost_to_clients_bank",
  NotInterested = "not_interested",
  Other = "other",
  OutOfHlhlServiceArea = "out_of_hlhl_service_area",
  StoppedLooking = "stopped_looking",
  Wants101Arm = "wants_10_1_arm",
  WantsFha = "wants_fha",
  WantsVa = "wants_va",
}

export const WithdrawnReasonsDisplayValues: { [key in WithdrawnReasons]: string } = {
  [WithdrawnReasons.CalledTooSlow]: "Called too slow",
  [WithdrawnReasons.ClonedToNewApplication]: "Cloned to new application",
  [WithdrawnReasons.LostOnCredits]: "Lost on credits",
  [WithdrawnReasons.LostOnRate]: "Lost on rate",
  [WithdrawnReasons.LostToAgentsLender]: "Lost to agent's lender",
  [WithdrawnReasons.LostToClientsBank]: "Lost to client's bank",
  [WithdrawnReasons.NotInterested]: "Not interested",
  [WithdrawnReasons.Other]: "Other",
  [WithdrawnReasons.OutOfHlhlServiceArea]: "Out of HLHL service area",
  [WithdrawnReasons.StoppedLooking]: "Stopped looking",
  [WithdrawnReasons.Wants101Arm]: "Wants 10/1 ARM",
  [WithdrawnReasons.WantsFha]: "Wants FHA",
  [WithdrawnReasons.WantsVa]: "Wants VA",
};

export enum SuspendedReasons {
  MissingInformation = "missing_information",
  PendingDocumentationAssets = "pending_documentation_assets",
  PendingDocumentationCredit = "pending_documentation_credit",
  PendingDocumentationIncome = "pending_documentation_income",
  QualifiesForLessThanRequestedAmount = "qualifies_for_less_than_requested_amount",
}

export const SuspendedReasonsDisplayValues: { [key in SuspendedReasons]: string } = {
  [SuspendedReasons.MissingInformation]: "Missing Information",
  [SuspendedReasons.PendingDocumentationAssets]: "Pending Documentation - Assets",
  [SuspendedReasons.PendingDocumentationCredit]: "Pending Documentation - Credit",
  [SuspendedReasons.PendingDocumentationIncome]: "Pending Documentation - Income",
  [SuspendedReasons.QualifiesForLessThanRequestedAmount]:
    "Qualifies for less than requested amount",
};

export enum DECISION {
  INCOMPLETE = "incomplete",
  CONDITIONALLY_APPROVED = "conditionally_approved",
  SUSPENDED = "suspended",
  PENDING = "pending",
  MORTGAGE_APPROVED = "mortgage_approved",
  APPROVED_BUT_NOT_ACCEPTED = "approved_but_not_accepted",
  WITHDRAWN = "withdrawn",
  DENIAL_RECOMMENDED = "denial_recommended",
  MORTGAGE_DENIED = "mortgage_denied",
}

export const loanDecisions = [
  {
    value: DECISION.INCOMPLETE,
    label: "Incomplete",
  },
  {
    value: DECISION.CONDITIONALLY_APPROVED,
    label: "Conditionally Approved",
  },
  {
    value: DECISION.SUSPENDED,
    label: "Suspended",
  },
  {
    value: DECISION.PENDING,
    label: "Pending",
  },
  {
    value: DECISION.MORTGAGE_APPROVED,
    label: "Mortgage Approved",
  },
  {
    value: DECISION.APPROVED_BUT_NOT_ACCEPTED,
    label: "Approved but not Accepted",
  },
  {
    value: DECISION.WITHDRAWN,
    label: "Withdrawn",
  },
  {
    value: DECISION.DENIAL_RECOMMENDED,
    label: "Denial Recommended",
  },
  {
    value: DECISION.MORTGAGE_DENIED,
    label: "Mortgage Denied",
  },
];

export const loanDecisionToStr = decision => {
  const o = _.findWhere(loanDecisions, { value: decision });
  return o ? o.label : decision;
};
